var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('h4',{staticClass:"mb-4"},[_c('strong',[_vm._v("Equipamento ")])]),(_vm.loading)?[_c('a-skeleton',{attrs:{"active":""}})]:[_c('Form',{staticClass:"mt-2",attrs:{"device":_vm.device}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }